module.exports = __webpack_public_path__ + "img/wholesale-term-modal-image-01.efd2d0d.svg";